import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { combineLatest } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { ProviderOptionEnabledForHBClinical } from '../services';
import { AuthService } from '../services/auth.service';
import { ProviderService } from '../services/provider.service';
import { ProviderDataResolverService } from '../resolvers/provider-resolver.service';

@Injectable({
  providedIn: 'root',
})
export class HBClinicalContractGuard implements CanActivate {
  constructor(
    private router: Router,
    private providerService: ProviderService,
    private authService: AuthService,
    private providerDataResolver: ProviderDataResolverService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const tenantId = (route.params && route.params.tenantId) || null;

    // Guards run before the resolver, so the store may still hold the previous provider.
    // Load the target tenant first, then check its contract (#48625).
    return this.providerDataResolver.ensureProviderForTenant(tenantId, state.url).pipe(
      switchMap(() =>
        combineLatest([this.providerService.isLite$, this.providerService.isFull$, this.providerService.isHbcGo$]).pipe(take(1))
      ),
      map(([isLite, isFull, isHbcGo]) => isLite || isFull || isHbcGo || this.router.parseUrl(`/error/contract/${tenantId}`))
    );
  }

  hasHBClinicalContract(options: { [key: string]: string }) {
    return options && options[ProviderOptionEnabledForHBClinical] && options[ProviderOptionEnabledForHBClinical].toLowerCase() === 'true';
  }
}
